'use client';
import { Typography } from '@curology/ui-components-web/react';
import React from 'react';

import { NextBoxPricing } from '@/components/flow/expressCurologySignUpSkin/components/nextBoxPricing';
import { type ExpressCurologySignUpSkinPdpSourceConfigType } from '@/components/flow/expressCurologySignUpSkin/types';

export const HowItWorksAndNextBoxPricing = ({
  bundleConfig,
  selectedAddOnProductItemIds,
}: {
  bundleConfig: ExpressCurologySignUpSkinPdpSourceConfigType;
  selectedAddOnProductItemIds: number[];
}) => {
  return (
    <div className="cur-bg-surface-neutral">
      <div className="cur-border-b cur-border-disabled cur-border-solid cur-p-4">
        <Typography className="cur-mb-3" weight="bold">
          How it works
        </Typography>
        <ul className="cur-m-0">
          <li className="cur-flex cur-mb-3">
            <div className="cur-bg-surface-brand cur-h-[14.4px] cur-flex cur-font-bold cur-items-center cur-justify-center cur-mr-3 cur-mt-2 cur-rounded-[100%] cur-text-inverse cur-text-[8px] cur-w-[14.4px]">
              1
            </div>
            <Typography className="cur-flex-1" size="meta">
              Answer quick questions about your skin and goals, plus share
              photos.
            </Typography>
          </li>
          <li className="cur-flex cur-mb-3">
            <div className="cur-bg-surface-brand cur-h-[14.4px] cur-flex cur-font-bold cur-items-center cur-justify-center cur-mr-3 cur-mt-2 cur-rounded-[100%] cur-text-inverse cur-text-[8px] cur-w-[14.4px]">
              2
            </div>
            <Typography className="cur-flex-1" size="meta">
              A licensed dermatology provider reviews your info to prescribe
              your personalized formula(s).
            </Typography>
          </li>
          <li className="cur-flex cur-mb-3">
            <div className="cur-bg-surface-brand cur-h-[14.4px] cur-flex cur-font-bold cur-items-center cur-justify-center cur-mr-3 cur-mt-2 cur-rounded-[100%] cur-text-inverse cur-text-[8px] cur-w-[14.4px]">
              3
            </div>
            <Typography className="cur-flex-1" size="meta">
              We&apos;ll send your first 30-day supply of personalized skincare.
            </Typography>
          </li>
          <li className="cur-flex">
            <div className="cur-bg-surface-brand cur-h-[14.4px] cur-flex cur-font-bold cur-items-center cur-justify-center cur-mr-3 cur-mt-2 cur-rounded-[100%] cur-text-inverse cur-text-[8px] cur-w-[14.4px]">
              4
            </div>
            <Typography className="cur-flex-1" size="meta">
              Your provider is always available to answer questions, adjust your
              treatment, and provide ongoing care.
            </Typography>
          </li>
        </ul>
      </div>
      <div className="cur-p-4">
        <div className="cur-mb-3">
          <NextBoxPricing
            bundleConfig={bundleConfig}
            selectedAddOnProductItemIds={selectedAddOnProductItemIds}
          />
        </div>
        <Typography size="meta">Subject to medical consultation.</Typography>
      </div>
    </div>
  );
};
